module.exports = __webpack_public_path__ + "static/media/bug.8b5c4b8c.jpg";